import repository from '@/core/repository/repository'
import store from '@/store'
import i18n from '@/core/localization/i18n'
import _ from 'lodash'
import $ from 'jquery'
import { tryRegisterSentry } from '@/core/error-handler'
import localizationService from '@/core/services/localization-service'
import Vue from 'vue'

function loadTranslations() {
  return repository.get('translations').done(translations => {
    _.forOwn(translations, (messages, culture) => {
      i18n.setLocaleMessage(culture, messages)
    })
  })
}

function loadUnits() {
  return repository.get('company').done(companies => {
    store.dispatch('setStaticData', { key: 'companies', data: companies })
  })
}

function loadConfig() {
  return repository.get('configuration').done(configuration => {
    store.dispatch('setStaticData', { key: 'configuration', data: configuration })
  })
}

function loadStaticData() {
  return repository.get('staticdata').done(response => {
    _.forEach(response, (data, key) => {
      store.dispatch('setStaticData', { key, data })
    })
  })
}

function loadApp() {
  return loadConfig().then(() => {
    tryRegisterSentry()
    const promises = [loadStaticData(), loadTranslations()]
    return $.when.apply($, promises).done(() => {
      initializeLocale()
    })
  })
}

function initializeLocale() {
  const defaultLocale = localizationService.getDefaultLocale()
  localizationService.setLocale(defaultLocale)
  store.dispatch('setUserLanguage', defaultLocale)
  localizationService.watchLanguageChange()
}

function registerComponents() {
  const components = require.context('@/components', true, /[A-Z]\w+\.(vue)$/)
  _.forEach(components.keys(), (fileName) => {
    const componentConfig = components(fileName)
    const componentName = 'Polygon' + fileName.split('/').pop().split('.')[0]
    Vue.component(componentName, componentConfig.default || componentConfig)
  })
}

export { loadApp, registerComponents, loadUnits }
